export default "/images/53e89938c44d10bfd65a42facfb26152.avif";